import { Avatar } from '@mui/material';
import React, { useState } from 'react';
import { Button, Col, Form, Image, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import MessageService from '../../../helpers/services/communication/message';
import MessageServiceErrorParser from '../../../helpers/services/communication/error';
import OnScreenLoader from './OnScreenLoader';
import { createNotification } from 'react-redux-notify';
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from '../../helper/NotificationMessage';

import CloseIcon from '../../../images/icons/close-thin.svg?react';

import './styles/PerformerOffline.css';

const defaultProfile =
  'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg';

const SendMessageToPerformer = ({ data, onSuccess, messageText, hideUsername }) => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const inputText = event.target.value;
    setMessage(inputText.substring(0, 100));
  };

  async function handleSendMsgToPerformer() {
    if (!message) {
      dispatch(createNotification(getErrorNotificationMessage('Please enter a message')));

      return;
    }

    try {
      setLoading(true);
      await MessageService.sendMessageToPerformer({
        receiver_id: `${data.receiver_id}`,
        type: 'text',
        text: `I'd like to request a Face2Face with you, can you let me know when you're free?\nI'd also like for you to know that: '${message}'`,
        price: 0,
      });

      dispatch(createNotification(getSuccessNotificationMessage('Message sent successfully')));

      onSuccess();
    } catch (error) {
      dispatch(
        createNotification(
          getErrorNotificationMessage(
            MessageServiceErrorParser.parseApiError(error.response)?.message,
          ),
        ),
      );
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <OnScreenLoader loader={loading} />
      <Row>
        <Col sm={12} md={12}>
          <div
            style={{ marginTop: '5vh' }}
            className='d-flex justify-content-center align-items-center text-center mt-100'
          >
            <Avatar
              src={data?.performer?.picture || defaultProfile}
              style={{ width: '90px', height: '90px' }}
              className=' img-fluid'
              alt='avtar'
            >
              <img
                src={data?.performer?.picture}
                style={{ width: '50px', height: '50px' }}
                alt='profile'
              />
            </Avatar>
          </div>
          {!hideUsername && (
            <div className='d-flex justify-content-center align-items-center text-center'>
              {data?.performer?.name || data?.performer?.username || 'UserName'} <br />
            </div>
          )}
        </Col>
      </Row>
      <div className='f2f-leave-message-on-offline-container'>
        <Row>
          <Form.Group className='mb-3' controlId='exampleForm.ControlTextarea1'>
            {messageText && <p className='text-center'>{messageText}</p>}
            <Form.Label className='f2f-footer-flip-btn-col'>Leave a Message</Form.Label>
            <Form.Control
              as='textarea'
              className='f2f-send-message-textarea'
              rows={6}
              value={message}
              onChange={handleChange}
            />
            <Row className='bg-white f2f-send-message-footer'>
              <Col xs={6} className='f2f-footer-mute-btn-col'>
                {100 - message.length}/100
              </Col>
              <Col xs={6} className='f2f-footer-video-btn-col'>
                <Button
                  type='submit'
                  className='primary btn btn-primary bg-white border-white'
                  onClick={() => handleSendMsgToPerformer()}
                >
                  <Image
                    src='https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/arrow-icons_send.svg'
                    round
                    alt='arrow icon'
                  />
                </Button>
              </Col>
            </Row>
          </Form.Group>
        </Row>
        <Row className='f2f-message-close-btn-container'>
          <Col xs={12} className='f2f-message-close-btn'>
            <CloseIcon
              role={'button'}
              style={{ width: '50%', height: '50%' }}
              alt='accept'
              aria-label='call accept'
              onClick={onSuccess}
            />
          </Col>
          <Col xs={12}>close</Col>
        </Row>
      </div>
    </>
  );
};

export default SendMessageToPerformer;
